module.exports = __webpack_public_path__ + "img/stag.f0093bcf.png";